import { useEffect, useState } from "react"
import { rawCategories } from "../rawData/categories"
import { tasks } from "../rawData/tasks"
import { contacts } from "../rawData/contacts"

export const useData = (type) => {
    const [data, setData] = useState(null)

    const findById = ( id ) => {
        if (data) {
            return data.find( (d) => d.id === id)
        }
    }

    const filterBy = ( key, value ) => {
        if (data) {
           const filteredData = data.filter( (d) => {
            return d[key] === value
           })
           return filteredData
        }
    }

    useEffect( () => {
        console.log("use effect in useData : " + type)
        switch (type) {
            case 'CATEGORIES':
                setData(rawCategories)
                break;
            case 'TASKS':
                setData(tasks)
                break;
            case 'CONTACTS':
                setData(contacts)
            default:
                break;
        }
    },[type])

    return { 
        data, 
        findById, 
        filterBy
    }
}